import { useEnvironment } from "../../components/EnvironmentProvider/EnvironmentProvider";
import { datadogLog } from "./Logging-utils";
/**
 * Hook for logging events to DataDog
 *
 */
export const useLogging = () => {
    const { buildVersion, environment, application } = useEnvironment();
    return {
        datadogLog: datadogLog(environment, buildVersion, application),
    };
};
